import { EnvironmentEnum } from './index';

export default {
  ENVIRONMENT: EnvironmentEnum.STAGING,
  API_URL: 'https://haul-safe-document-api-staging.haulwith.us',
  WS_URL: 'wss://haul-safe-document-api-staging.haulwith.us',
  TICKET_ID_PREFIX: 'HAUL-',
  FMCSA: {
    LINK_FOR_CHECK:
      'https://nationalregistry.fmcsa.dot.gov/search-medical-examiners?as=true&range=10',
  },
  HAULSAFE_PHONE_NUMBER: '(479) 342-4808',
  SEGMENT_ID: 'OZR9qfFoqiuuaoDjkEMpZrdPI8Ufe6GE',
  LOGS_LEVEL: process.env.REACT_APP_LOG_LEVEL || 'info',
  LOGS_PROVIDERS: ['console', 'sentry'],
  SENTRY_DSN:
    process.env.REACT_APP_SENTRY_DSN ||
    'https://e0ed54dd29f2456faadba1caee1bfe71@o362769.ingest.sentry.io/4505250751971328',
};
